import { redirect } from "@tanstack/react-router";
import { queries } from "@theprelude/core";
import { Feature } from "@theprelude/sdk";
import { hasFeatures } from "@/components/flag/flag";
import { RouterContext } from "@/main";

export const authorizeFeatures = async (
  context: RouterContext,
  features: Feature[],
): Promise<void> => {
  const authConfig = await context.auth.getAuthConfig();
  const account = await context.queryClient.ensureQueryData(
    queries.iam.getAccount(authConfig),
  );

  const isAuthorized = hasFeatures(account, features);
  if (!isAuthorized) {
    throw redirect({
      to: "/home",
    });
  }
};
